export const getPeopleLoading = (state) => state.people.loading;
export const getPeopleList = (state) => state.people.data;
export const getCreateShow = (state) => state.people.createShow;
export const getPeopleState = (state) => state.people;
export const getCheckedPeople = (state) => state.people.checkedItems;
